import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWarehouses } from "redux/actions/warehousesCatalog/warehousesCatalogActions";

export const useTransferWarehouses = ({ isTransfer, stationDestino, mov, setValues }) => {
  const dispatch = useDispatch();
  const { warehousesArr } = useSelector(({ warehousesCatalog }) => warehousesCatalog);
  const { token } = useSelector(({ login }) => login);

  const warehouseOptions = useMemo(() => {
    if (!isTransfer || !stationDestino) return [];
    return warehousesArr
      .filter((wh) => wh.idStation === stationDestino?.id)
      .map((wh) => ({
        ...wh,
        label: `${wh.number} - ${wh?.creLicense}`,
        value: wh.id,
      }));
  }, [isTransfer, stationDestino, warehousesArr]);

  useEffect(() => {
    if (isTransfer && warehousesArr.length === 0) {
      dispatch(getWarehouses(token));
    }
  }, [isTransfer]);

  useEffect(() => {
    if (!mov?.idStorageDestino || !warehousesArr.length) return;
    if (typeof mov.idStorageDestino === "object") {
      setValues({ idStorageDestino: mov.idStorageDestino });
      return;
    }
    const found = warehousesArr.find((wh) => wh.id === mov.idStorageDestino);
    if (found) {
      setValues({
        idStorageDestino: {
          ...found,
          label: found.number + " - " + (found.creLicense || ""),
          value: found.id,
        },
      });
    }
  }, [warehousesArr, mov?.idStorageDestino]);

  return { warehouseOptions };
};
